(function () {
  'use strict';

  /* @ngdoc object
   * @name employeePayroll
   * @description
   *
   */
  angular
    .module('employeePayroll', [
      'ui.router'
    ]);
}());
